const base = {
  rota: "cobranca",
  name: "Cobranca"
};

const routes = [
  {
    path: `/${base.rota}`,
    component: () => import("./views/List.vue"),
    name: base.name
  }
];

export default {
  routes
};
